import { coerceSizeValue } from '../../../utils/coerceSizeValue.js';
import {
  ChartLayoutDimensions,
  ChartLayoutGridSettings,
} from '../types/chart-layout.js';
import {
  DEFAULT_LAYOUT_HEIGHT,
  DEFAULT_LAYOUT_WIDTH,
  TEMPLATE_AREA_FOR_FIXED_CHART_LAYOUT,
  TEMPLATE_AREA_FOR_GRAPH,
  TEMPLATE_AREA_FOR_RESIZABLE_CHART_LAYOUT,
} from '../types/constants.js';
import { coerceWidthValue } from './coerce-width-value.js';

export const getTemplateArea = (hasLegend: boolean, hasResizer: boolean) => {
  if (!hasLegend) {
    return TEMPLATE_AREA_FOR_GRAPH;
  }
  if (hasLegend && hasResizer) {
    return TEMPLATE_AREA_FOR_RESIZABLE_CHART_LAYOUT;
  }
  return TEMPLATE_AREA_FOR_FIXED_CHART_LAYOUT;
};

export const getGridTemplate = (hasLegend: boolean, hasResizer: boolean) => {
  let gridTemplate = '1fr';
  if (hasLegend) {
    gridTemplate += ' min-content';
    if (hasResizer) {
      gridTemplate += ' min-content';
    }
  }

  return gridTemplate;
};

/**
 * Function responsible for generating the configuration for the chart layout Grid.
 * @param chartWidth -
 * @param chartHeight -
 * @param containerSizes -
 * @param hasResizableLegend -
 * @param showResizer -
 */
export const getLayoutGridSettings = (
  chartWidth: string | number | undefined,
  chartHeight: string | number | undefined,
  containerSizes: ChartLayoutDimensions,
  hasResizableLegend: boolean,
  showResizer: boolean,
): ChartLayoutGridSettings => {
  const templateAreas = getTemplateArea(hasResizableLegend, showResizer);
  const gridTemplate = getGridTemplate(hasResizableLegend, showResizer);
  const horizontalPadding =
    containerSizes.padding.left + containerSizes.padding.right;
  const layoutWidth =
    coerceWidthValue(chartWidth, horizontalPadding) ?? DEFAULT_LAYOUT_WIDTH;
  const layoutHeight = coerceSizeValue(chartHeight) ?? DEFAULT_LAYOUT_HEIGHT;

  return {
    layoutWidth,
    layoutHeight,
    templateAreas,
    gridTemplate,
  };
};
